import api from "../../api";
import { getBackendUrl } from "../../util/envFn";
import { User } from "../../types/User";

export const fetchUsers = async (search: string, location: string, sortBy: string, sortOrder: string): Promise<User[]> => {
    const res = await api.get(getBackendUrl('/users'), { params: { search, location, sortBy, sortOrder } });
    return res.data.map((user: User) => ({
        id: user._id,
        ...user,
    }));
};